module.exports = __webpack_public_path__ + "static/img/200045.795c145b.png";